import { createReducer, on } from '@ngrx/store';
import { ALERT_FETCH_ERROR, ALERT_FETCH_PENDING, ALERT_FETCH_SUCCESS, } from 'AlertsApp/ts/features/alerts-modals/constants';
import { fetchAlerts, resetErrorMessage, setAlertFetchFailure, setAlertFetchSuccess, setErrorMessage, } from './alert-modal-status.actions';
export const alertModalStatus = createReducer({ status: ALERT_FETCH_PENDING, errorMessage: undefined }, on(fetchAlerts, (state) => {
    return { ...state, status: ALERT_FETCH_PENDING };
}), on(setAlertFetchSuccess, (state) => {
    return { ...state, status: ALERT_FETCH_SUCCESS };
}), on(setAlertFetchFailure, (state, action) => {
    return { ...state, status: ALERT_FETCH_ERROR, errorMessage: action.errorMessage };
}), on(setErrorMessage, (state, action) => {
    return { ...state, errorMessage: action.errorMessage };
}), on(resetErrorMessage, (state) => {
    return { ...state, errorMessage: undefined };
}));
